//==============ResetPasswordCtrl controller==================
'use strict';
App.controller('ResetPasswordCtrl',['$scope','$http','$location','ngDialog','$state','$timeout','$stateParams','Api','toastr','$window', 'UsersClientService', 'ProfessionalService', '$localStorage',
    function ($scope,$http,$location,ngDialog,$state,$timeout,$stateParams,Api,toastr,$window, UsersClientService, ProfessionalService, $localStorage) {

        $scope.user={};
        $scope.show_reset = false;
        $scope.unAuthorized = false;
        
        this.$onInit = async function (){
            const { email, token } = $stateParams;
            try {
                const data = await ProfessionalService.get(email, { passwordResetToken: token });
                const affiliations = _.get(data, 'affiliations', []);
                if(affiliations.length && affiliations.length < 2){
                    $scope.logoUrl = _.get(data, 'affiliations[0].organization.facility.logoURL');
                    $localStorage.coBrandedKEY = _.get(data, 'affiliations[0].organization.coBrandedUrl');
                }
            }catch (e) {
                let errMessage = e.message;
                if (e.statusCode === 403) {
                    $scope.unAuthorized = true;
                    errMessage = "This link has already expired or is invalid.";
                }
                toastr.error(errMessage);
            }finally {
                $scope.show_reset = $scope.unAuthorized ? false : true;
                $scope.$applyAsync();
            }
        }

        // =============to close popup=============
        $scope.closePopup = function () {
            ngDialog.closeAll();
        }

        $scope.resetPasswordSubmit  = function () {
            const { email, token } = $stateParams;
            UsersClientService.resetPassword(email, token, $scope.user.password)
                .then(() => {
                    toastr.success('Password changed successfully');
                    if($localStorage.coBrandedKEY){
                        $state.go('coBrandedLogin', { coBrandedKEY: $localStorage.coBrandedKEY });
                    } else {
                        $state.go('login');
                    }
                })
                .catch(() => {
                    $scope.show_reset = false;
                    $scope.$apply();
                });
        }
    
        $scope.backToLogin = function () {
            if($localStorage.coBrandedKEY){
                $state.go('coBrandedLogin', { coBrandedKEY: $localStorage.coBrandedKEY });
            } else {
                $state.go('login');
            }
        }

}]);
